import axiosInstance from './axiosInstance';

export interface HrAuditIssue {
  entityType: string;
  entityId?: number;
  entityCode?: string;
  entityName?: string;
  branchId?: number;
  branchName?: string;
  description: string;
  descriptionAr: string;
  suggestedFix: string;
  suggestedFixAr: string;
}

export interface HrAuditCheck {
  code: string;
  title: string;
  titleAr: string;
  category: string;
  categoryAr: string;
  severity: 'Critical' | 'Warning' | 'Info';
  issueCount: number;
  issues: HrAuditIssue[];
  passMessage: string;
  passMessageAr: string;
}

export interface HrAuditReport {
  generatedAt: string;
  periodFrom?: string;
  periodTo?: string;
  totalChecks: number;
  checksPassed: number;
  checksWithIssues: number;
  criticalCount: number;
  warningCount: number;
  infoCount: number;
  checks: HrAuditCheck[];
}

const BASE = '/HrAudit';

export const hrAuditService = {
  run(fromDate?: string, toDate?: string): Promise<HrAuditReport> {
    const params: Record<string, string> = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    return axiosInstance.get(`${BASE}/run`, { params }).then(r => r.data);
  }
};

export default hrAuditService;
